import axios from 'axios';
import Auth from './auth';
import { API_ROOT } from './apiConfig';

export default class ENTSystemDataAccess {
   
    getENTSettings() {
        const auth = new Auth();

        return new Promise((resolve, reject) => {

            let reqBody = {
                account: "zuludatabase", command: "GetEOMSettings"
            };

            axios.post(`${API_ROOT}/api/v1/qtype/Query`, reqBody,
                {
                    headers: {
                        "Content-Type": "application/json",
                        "Authorization": `Bearer ${auth.getToken()}`
                    }
                }).then(function (response) {
                    sessionStorage.setItem('passSettings', JSON.stringify(response.data[0]));
                    resolve(response.data[0]);
                })
                .catch(error => {
                    console.log(error);
                });
        });
    }
}